"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var Carousel_1 = __importDefault(require("../../../components/Carousel/Carousel"));
var CatalogHeader = function () {
    var banners = (0, react_redux_1.useSelector)(function (state) { return state.app.banners; });
    var data = (banners === null || banners === void 0 ? void 0 : banners.map(function (item) { return ({ image: item.image.url, caption: "" }); })) || [];
    return ((0, jsx_runtime_1.jsx)("header", __assign({ className: "catalog-header" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "banners-container" }, { children: (0, jsx_runtime_1.jsx)(Carousel_1.default, { data: data, time: 10000, width: "3250px", height: "290px", captionStyle: {
                    fontSize: "2em",
                    fontWeight: "bold",
                }, slideNumber: false, slideNumberStyle: {
                    fontSize: "20px",
                    fontWeight: "bold",
                }, captionPosition: "center", automatic: false, dots: data.length > 1, slideBackgroundColor: "darkgrey", slideImageFit: "cover", thumbnails: false, thumbnailWidth: "100px", style: {
                    textAlign: "center",
                    maxHeight: "290px",
                    margin: "0 auto",
                } }) })) })));
};
exports.CatalogHeader = CatalogHeader;
